import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

// conponents
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";
import { GET_INDEBTED } from "../../apollo/ordergroup/query";

// apollo-client
import { useApolloClient, useLazyQuery } from "@apollo/client";

// icons
import SearchIcon from "@mui/icons-material/Search";

// react-bootrap
import { Form, InputGroup, Card, Row, Col, Table, Spinner, Button } from "react-bootstrap";
import "./HistoryIndebted.css";
import PaginationsV2 from "../../components/PaginationsV2";
import { IndeterminateCheckBoxSharp } from "@mui/icons-material";
import { covertTimeZone, numberFormat } from "../../helper";
import { MdOutlineDateRange } from "react-icons/md";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import { t } from "i18next";
import * as XLSX from "xlsx/xlsx.mjs";
// import BreadCrumbComponent from "../../components/BreadCrumbComponent";

export default function HIstoryIndebted() {
  const history = useHistory();
  const client = useApolloClient();
  const [searchText, setSearchText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [indebted, setIndebTed] = useState();
  const [totalIndebted, setTotalIndebTed] = useState();
  const [filteredIndebted, setFilteredIndebted] = useState([]);
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [isExporting, setIsExporting] = useState(false);
  const [filter, setFilter] = useState({
    createdAt_gte: '',
    createdAt_lt: '',
  });
  const sortedIndebted = filteredIndebted?.slice()?.sort((a, b) => {
    const nameA = a.customerName?.toLowerCase() || "";
    const nameB = b.customerName?.toLowerCase() || "";
    return nameA.localeCompare(nameB);
  });

  const totalBill = useMemo(() => {
    return sortedIndebted?.reduce((acc, cur) => acc + parseInt(cur.billQty), 0);
  }, [sortedIndebted]);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [loadindebted, { data: GetIndebTed, loading }] = useLazyQuery(
    GET_INDEBTED,
    { fetchPolicy: "cache-first" }
  );

  // ============== > useEffect <==============

  const [page, setPage] = useState(0);

  useEffect(() => {
    if (GetIndebTed) {
      setIndebTed(GetIndebTed?.indebteds?.data);
      setTotalIndebTed(GetIndebTed?.indebteds?.total);
    }
  }, [GetIndebTed, page]);

  const rowsPerPage = 50;
  const pageAll = GetIndebTed?.indebteds?.total > 0 ? Math.ceil(GetIndebTed?.indebteds?.total / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  useEffect(() => {
    setFilteredIndebted(indebted);
  }, [indebted]);

  useEffect(() => {
    _fetchIndebTed();
  }, [searchQuery, page, filter]);

  // ============== > fuctions <==============

  const buildWhere = () => {
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    const _where = {
      shop: shopId,
      isDeleted: false,
      status: "INDEBTED",
      ...(filter?.createdAt_gte ? { createdAt_gte: filter.createdAt_gte } : {}),
      ...(filter?.createdAt_lt ? { createdAt_lt: filter.createdAt_lt } : {}),
    };

    if (searchQuery) {
      if (/^\d+$/.test(searchQuery)) {
        _where.phone = searchQuery;
      } else {
        _where.customerName = searchQuery;
      }
    }
    return _where;
  };

  const _fetchIndebTed = async () => {
    const _where = buildWhere();
    await loadindebted({
      variables: {
        skip: page * rowsPerPage,
        limit: rowsPerPage,
        where: _where,
      },
    });
  };

  const handleExportExcel = async () => {
    try {
      if (isExporting) return;
      setIsExporting(true);

      const _where = buildWhere();
      const limit = 500;
      let skip = 0;
      let total = 0;
      const allData = [];

      while (true) {
        const result = await client.query({
          query: GET_INDEBTED,
          variables: {
            where: _where,
            skip,
            limit,
            orderBy: "customerName_ASC",
          },
          fetchPolicy: "network-only",
        });

        const pageData = result?.data?.indebteds?.data || [];
        total = result?.data?.indebteds?.total ?? total;
        allData.push(...pageData);

        if (pageData.length < limit || allData.length >= total) break;
        skip += limit;
      }

      const rows = allData.map((r, idx) => ({
        ລຳດັບ: idx + 1,
        ຊື່ລູກຄ້າ: r?.customerName ?? "-",
        ນາມສະກຸນ: r?.customerLastName ?? "-",
        ເບີໂທຕິດຕໍ່: r?.phone ?? "-",
        ຈຳນວນບິນ: r?.billQty ?? 0,
        ຍອດສີນຄ້າ: r?.amount ?? 0,
        ຍອດເງີນ: r?.sumPrice ?? 0,
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `indebted_${new Date().toISOString().slice(0, 10)}.xlsx`);
    } catch (error) {
      console.log("Export Error:", error);
    } finally {
      setIsExporting(false);
    }
  };

  const handleSearch = () => {
    if (searchQuery === searchText) {
      _fetchIndebTed();
    } else {
      setPage(0);
      setSearchQuery(searchText);
    }
  };

  const handleDetailIndebted = (id, state) => {
    history.push("/indebted_detail/" + id, { state });
  };

  return (
    <React.Fragment>
      <div  style={{ padding: "1em 1.5em" }}>
      
        <div className="header-section">
          <h4 className="page-title">
            <b>ປະຫວັດການ ຄ້າງໜີ້</b>
          </h4>
          <p className="page-description">
            ປະຫວັດອໍເດີ້ທີ່ລູກຄ້າຕິດໜິ້ໄວ້
          </p>
          
          {/* Statistics Cards */}
          <div className="stats-container">
            <div className="stat-card">
              <div className="stat-icon customers-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{totalIndebted || 0}</h3>
                <p className="stat-label">ລູກຄ້າທັງໝົດ</p>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon bills-icon">
                <i className="fas fa-file-invoice"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{totalBill || 0}</h3>
                <p className="stat-label">ບີນທັງໝົດ</p>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-icon items-icon">
                <i className="fas fa-box"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{GetIndebTed?.indebteds?.totalAmount || 0}</h3>
                <p className="stat-label">ລາຍການສີນຄ້າ</p>
              </div>
            </div>
            
            <div className="stat-card highlight-card">
              <div className="stat-icon amount-icon">
                <i className="fas fa-money-bill-wave"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{numberFormat(GetIndebTed?.indebteds?.totalSumPrice) || '0'}</h3>
                <p className="stat-label">ຍອດເງີນທັງໝົດ (LAK)</p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-start align-items-center">
            <div
          style={{
            width: "100%",
          marginBottom: "1em",
          }}>
          <Form.Label>ຊອກຫາ</Form.Label>
              <InputGroup style={{ width: "100%", maxWidth: 300 }}>
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF", 
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} 
                  style={{ cursor: "pointer" }}
                   onClick={handleSearch}
                   />
                </InputGroup.Text>
                <Form.Control
                  placeholder="ປ້ອນຊື່ຫຼືເບີໂທ..."
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  }}
                  value={searchText}
                  style={{
                    borderLeft: "none",
                  }}
                />
              </InputGroup>
            </div>
            <Col sm style={{ display: 'flex', flexDirection: 'column', gap: 3 , minWidth: '300px'}}>
              <Form.Label>{t("day_month_year")}</Form.Label>
              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
              >
                {loading && !GetIndebTed ? (
                    <Spinner size="sm" />
                ) : (
                  <MdOutlineDateRange style={{ fontSize: 24 }} />
                )}
                &nbsp;  &nbsp;
                {!filter?.createdAt_gte ? (
                  "mm/dd/yyyy"
                ) : (
                  <>
                    {covertTimeZone(filter?.createdAt_gte) +
                      " - " +
                      covertTimeZone(filter?.createdAt_lt)}
                  </>
                )}
              </Button>
            </Col>
            <Col sm style={{ display: 'flex', flexDirection: 'column', gap: 3 , minWidth: '220px',marginLeft:10}}>
              <Form.Label>Export Excel</Form.Label>
              <Button
                variant="success"
                disabled={isExporting}
                onClick={handleExportExcel}
                style={{ marginTop: '-.2em', width: '100%' }}
              >
                {isExporting ? "ກຳລັງບັນທຶກ..." : "Export ທັງໝົດ"}
              </Button>
            </Col>
        </div>
        {loading && !GetIndebTed ? (
          <AnimationLoading />
        ) : (
          <Card>
            <Table
              hover
              style={{
                borderCollapse: "collapse",
                width: "100% ",
              }}>
              <thead>
                <tr>
                  <th>ລຳດັບ</th>
                  <th>ຊື່ລູກຄ້າ</th>
                  <th>ນາມສະກຸນ</th>
                  <th>ເບີໂທຕິດຕໍ່</th>
                  <th>ຈຳນວນບິນ</th>
                  <th>ຍອດສີນຄ້າ</th>
                  <th>ຍອດເງີນ</th>
                </tr>
              </thead>
              <tbody>
                {sortedIndebted?.map((indebteds, index) => (
                  <tr key={IndeterminateCheckBoxSharp}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleDetailIndebted(indebteds?.customerId, indebteds)
                    }>
                    <td>{page * rowsPerPage + index + 1}</td>
                    <td>{indebteds?.customerName ?? "-"}</td>
                    <td>{indebteds?.customerLastName ?? "-"}</td>
                    <td>{indebteds?.phone ?? "-"}</td>
                    <td>{indebteds?.billQty ?? "0"}</td>
                    <td>{indebteds?.amount || '0'}</td>
                    <td>{numberFormat(indebteds?.sumPrice) ?? "0"} LAK</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        )}
        <div style={{ marginTop: ".8em" }}>
          <PaginationsV2
            count={GetIndebTed?.indebteds?.total}
            rowsPerPage={rowsPerPage}
            page={page}
            pageAll={pageAll}
            onPageChange={handleChangePage}
          />
        </div>
        {sortedIndebted?.length <= 0 && (
          <div
            style={{
              fontSize: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#6B7280",
              fontWeight: "400",
            }}>
            <EmptyComponent />
            <p>ຍັງບໍ່ມີປະຫວັດການຕິດໜີ້ !!!</p>
          </div>
        )}
      </div>
      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </React.Fragment>
  );
}
